<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Clipboard_Box"
      data-name="Icon/Clipboard Box"
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 12.938 14.376"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Clipboard"
        data-name="Icon/Icon/Clipboard"
        d="M10.782,14.376H2.156A2.159,2.159,0,0,1,0,12.219V4.313A2.159,2.159,0,0,1,2.156,2.156V1.437A1.439,1.439,0,0,1,3.594,0H9.345a1.439,1.439,0,0,1,1.437,1.437v.719a2.159,2.159,0,0,1,2.156,2.156v7.907A2.159,2.159,0,0,1,10.782,14.376ZM2.156,3.594a.72.72,0,0,0-.719.719v7.907a.72.72,0,0,0,.719.719h8.626a.72.72,0,0,0,.719-.719V4.313a.72.72,0,0,0-.719-.719v.719A1.439,1.439,0,0,1,9.345,5.75H3.594A1.439,1.439,0,0,1,2.156,4.313ZM3.594,1.437V4.313H9.345V1.44Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ClipboardIcon extends Vue {}
</script>

<style>
</style>
